<template>
  <NavTopVue v-if="role === 'USER_ROLE' && setPermission" />
  <NavComponent v-if="role === 'USER_ROLE' && setPermission" />

  <SidebarMuni v-if="hasMuniAccess && setPermission" :isOpen="currentSidebarState" />

  <div style="position: relative">
    <SpinnerLoading v-if="$store.state.loadingGlobal" />

    <div class="layout-wrapper">
      <router-view />
      <NotificationGlobal v-if="hasMuniAccess && setPermission" />
      <FooterComponent v-if="
        role === 'USER_ROLE' &&
        setPermission &&
        role != 'MUNI_ROLE' &&
        role != 'SUPERVISOR_ROLE' &&
        role != 'ADMIN_ROLE'
      " />
    </div>
  </div>
  <!-- <NotificationContainer v-if="hasMuniAccess && setPermission" /> -->

  <InstallPwaButton />
</template>

<script>
import NavComponent from "@/components/Navs/NavComponent.vue";
import NavTopVue from "./components/Navs/NavTopComponent.vue";
import FooterComponent from "./components/Footer/FooterComponent.vue";
//MUNICIPALES
import SidebarMuni from "./components/Municipal/Sidebar/SidebarMuni.vue";
import SpinnerLoading from "./components/Municipal/Commons/SpinnerLoading.vue";
import InstallPwaButton from "./components/PWA/InstallPwaButton.vue";
import NotificationGlobal from "./components/NotificationGlobal.vue";
import { registerSWListener } from "./services/notifications/registerSWListener";
import { handlePushNavigation } from "./services/notifications/pushNavigationService";
import { initTheme } from "./services/helpers/themeHelper";
import { solicitarPermisoNotificaciones } from "./services/notifications/permissionService";
// import NotificationContainer from "./components/NotificationGlobal/NotificationContainer.vue";

export default {
  data() {
    return {
      role: null,
      cuil: "",
      ancho: "",
      margin: "",
      posision: "",
      derecha: "",
      asd: this.$route.fullPath,
      notLogin: false,
      currentSidebarState: true,
    };
  },
  created() {
    this.role = sessionStorage.getItem("role") || null;
    let tokenLocal = localStorage.getItem("token") || null;
    const isLoginWithCidi =
      this.$route?.query?.cidi || window.location.href.includes("?cidi=");
    if (!tokenLocal && !isLoginWithCidi) {
      this.dispatchOutLogin();
    }
  },

  watch: {
    "$store.state.isSidebarOpen"(newVal) {
      this.currentSidebarState = newVal;
    },
    "$store.state.loggedIn"(newVal) {
      if (!newVal) return;

      handlePushNavigation(this.$router);
    },
    role(newRole) {
      this.setRoleTheme(newRole);
    },
    $route() {
      if (this.$route.name === "login" || !this.hasMuniAccess) {
        this.currentSidebarState = false;
      }
      this.role =
        sessionStorage.getItem("role") || localStorage.getItem("role");
    },

    hasMuniAccess(newVal) {
      if (newVal) {
        this.$store.dispatch("notification/fetch");
      }
    },
  },

  async mounted() {
    this.setRoleTheme(this.role);

    initTheme();

    this.$store.dispatch("notification/fetch");

    if ("serviceWorker" in navigator) {
      try {
        await navigator.serviceWorker.register("/service-worker.js");

        await navigator.serviceWorker.ready;
        registerSWListener(this.$router);

        if (this.$store.state.loggedIn) {
          await solicitarPermisoNotificaciones();
        }
      } catch (err) {
        console.error(err);
      }
    }

    this._onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        handlePushNavigation(this.$router);
      }
    };

    document.addEventListener("visibilitychange", this._onVisibilityChange);
  },

  beforeUnmount() {
    if (this._notiInterval) clearInterval(this._notiInterval);
    document.removeEventListener("visibilitychange", this._onVisibilityChange);
  },

  methods: {
    dispatchOutLogin() {
      this.$store.dispatch("mockOutAction");
    },
    setSideBar() {
      if (window.innerWidth <= 770) {
        this.$store.dispatch("setSidebarState", false);
      }
    },
    setRoleTheme(role) {
      const html = document.documentElement;

      if (["MUNI_ROLE", "ADMIN_ROLE", "SUPERVISOR_ROLE"].includes(role)) {
        html.setAttribute("data-role", "muni");
      } else if (role === "USER_ROLE") {
        html.setAttribute("data-role", "user");
      }
    },
  },

  computed: {
    setPermission() {
      return this.$store.state.loggedIn === true;
    },
    hasMuniAccess() {
      return ["MUNI_ROLE", "ADMIN_ROLE", "SUPERVISOR_ROLE"].includes(this.role);
    },

    /*isMuniAdminSupervisor() {
      return (
        this.role === 'MUNI_ROLE' ||
        this.role === 'ADMIN_ROLE' ||
        (this.role === 'SUPERVISOR_ROLE' && this.setPermission)
      );
    },*/
  },
  components: {
    NavComponent,
    NavTopVue,
    FooterComponent,
    SpinnerLoading,
    SidebarMuni,
    InstallPwaButton,
    NotificationGlobal,
    // NotificationContainer,
  },
};
</script>

<style>
@import "@/../assets/styles/typographyMuni.css";
@import "@/../assets/styles/typographyVecino.css";
@import "@/../assets/styles/theme.css";

*,
*::before,
*::after {
  box-sizing: border-box;
}

.layout-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  overflow-y: auto;
  overflow-x: hidden;
}

.view-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

:root {
  --blur: blur(20px);
  --heightModal: 48.414vh;
  /* modal de 290px de alto*/
  --heightComprobantes: 83.472vh;
  /* modal de 500px de alto*/
  --width: 65.886vw;
  /* componentes de vistas 902px*/
  --widthModal: 40.26vw;
  /* modal de 550px*/
  --widthNav: 16.98vw;
  --widthComprobantes: 51.24vw;
  /* modal de 700px */
  --widthModalMobile: 78vw;
  --heightModalMobile: 340px;
  --margin40: 6.678vh;
  /* 40px*/
  --margin60: 10.017vh;
  /* 60px*/
  --gap5: 0.835vh;
  --gap10: 1.669vh;
  /* 10px vertical */
  --gap15: 15px;
  /* 15px vertical */
  --gap20: 3.339vh;
  /* 20px vertical */
  --gap25: 4.174vh;
  /* 25px vertical */
  --gap30: 30px;
  /* 30px vertical */
  --gap50: 8.347vh;
  /* 50px vertical */
  --gapH5: 0.366vw;
  /* 5px horizontal */
  --gapH10: 0.732vw;
  /* 10px horizontal */
  --gapH15: 1.098vw;
  /* 15px horizontal */
  --gapH20: 1.464vw;
  /* 20PX horizontal */
  --gapH24: 1.757vw;
  /* 24px horizontal */
  --gapH30: 2.196vw;
  /* 30px horizontal */
  --gapH40: 2.928vw;
  /* 40px horizontal */
  --gapH50: 3.66vw;
  /* 50px horizontal */
  /* MOBILE */

  --vh: 1vh;

  --gapHM15: 4.16vw;
  --gapHM10: 2.77vw;
  --gapHM15: 4.16vw;
  --gapHM20: 5.55vw;
  --gapHM25: 6.94vw;
  --gapHM30: 8.33vw;
  --gapHM40: 11.11vw;

  /* VARIABLES LUQUE MUNICIPAL */

  --widthNavMuni: 15vw;

  :deep(.v-dialog) {
    box-shadow: none;
  }

  /*puesto debido a error en los modales de muni, a futuro se corrige y se quita quita propieda de bootstrap*/
  .modal-backdrop {
    --bs-backdrop-zindex: 0;
  }

  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

#app {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  .main-contentMuni {
    margin-left: 15.227vw;
  }

  user-select: none;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  font-weight: normal;
  font-style: normal;
  margin: 0;

  /* min-height: 100dvh; */
  background: var(--bg-primary);

  .backMuni {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
    background-color: var(--bg-popup);
  }

  a {
    text-decoration: none;
  }
}

:deep(.v-dialog) {
  box-shadow: none;
}

/* html,
body {
  height: 100dvh;
  overflow: hidden;
} */

@supports (height: 100dvh) {
  /* :root {
    --vh: 1dvh;
  } */
  /* html,
  body {
    height: 100dvh;
  } */
}

@media (max-width: 990px) {
  #app .main-contentMuni {
    margin-left: 0px;
  }

  #app {
    /* min-height: 100vh; */
    /* height: 100%;
    width: 100vw; */
    display: flex;
    flex-direction: column;
    scrollbar-width: none;
    overflow-x: hidden;
  }

  .layout-wrapper {
    display: flex;
    flex-direction: column;
    height: unset;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

/* ---------------------------- */
</style>

<style scoped>
@media (max-width: 770px) {
  #app {
    width: 100vw;
    height: 100%;
  }

  .footer {
    width: 100%;
    bottom: 0;
  }
}
</style>
